import React from "react";

export function Footer() {
  return (
    <div className="z-20 w-full bg-sidebar shadow backdrop-blur border-t border-border">
      <div className="mx-4 md:mx-8 flex h-14 items-center justify-center">
        <p className="text-xs md:text-sm leading-loose text-center">
          © 2024. GuideproAI All rights reserved.
        </p>
      </div>
    </div>
  );
}
